import { Entity, schema } from '@data-client/rest';
import { EncryptionGeofencingCountryEntity } from './EncryptionGeofencingCountry';
import { ISODate } from '../utils/transforms';
class EncryptionRestrictionEntity extends Entity {
    constructor() {
        super(...arguments);
        this.copyAllowed = false;
        this.decryptsPerUser = 0;
        this.encryptionId = 0;
        this.forwardAllowed = false;
        this.geofencingCountries = null;
        this.isGeofencingRestricted = false;
        this.linkedSessionsRequired = false;
        this.printAllowed = false;
        this.saveAllowed = false;
        this.sunriseDTTM = new Date(0);
        this.sunsetDTTM = new Date(0);
    }
    pk() {
        return this.encryptionId.toString();
    }
}
EncryptionRestrictionEntity.schema = {
    geofencingCountries: new schema.Collection([
        EncryptionGeofencingCountryEntity
    ]),
    sunriseDTTM: ISODate,
    sunsetDTTM: ISODate
};
EncryptionRestrictionEntity.key = 'EncryptionRestriction';
export { EncryptionRestrictionEntity };
